import React, { useState } from "react";
import "antd/dist/antd.css";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import Layout from "./Layout/Layout";
import { MyContext } from "./mycontext";
const INTERCOM_APP_ID = "rohlior3";

function App() {
  if (window.location.pathname === "/login") {
    document.body.style.backgroundColor = "white";
  } else {
    document.body.style.backgroundColor = "#FAFAFA";
    console.log(document.body.style.backgroundColor);
  }
  const [socket, setSocket] = useState(null);
  return (
    <BrowserRouter>
      <MyContext.Provider value={[socket, setSocket]}>
        <Layout>
          <Routes />
        </Layout>
      </MyContext.Provider>
    </BrowserRouter>
  );
}

export default App;
